import {
  checkIsMastraErrorToolOutput,
  type MastraErrorToolOutput,
} from "@repo/app-types/agents/mastraErrorToolOutput";
import type {
  GetSignalDetailsToolInput,
  GetSignalDetailsToolOutput,
} from "@repo/app-types/entities/copilot";
import { ChatToolBase, type ToolComponent } from "@repo/ui/chat/chatToolCall";

export const GetSignalDetailsTool: ToolComponent<
  GetSignalDetailsToolInput,
  GetSignalDetailsToolOutput | MastraErrorToolOutput
> = (props) => {
  const renderText = () => {
    if (props.status.type !== "complete" || !props.output) {
      return "Fetching signal details...";
    }

    if (checkIsMastraErrorToolOutput(props.output)) {
      return "An error occurred while fetching signal details";
    }

    if (!props.output.signal_details) {
      return "Signal not found";
    }

    return "Fetched signal details";
  };

  return <ChatToolBase status={props.status}>{renderText()}</ChatToolBase>;
};
